/*
 * @Author: Src
 * @Date: 2025-07-15 15:48:23
 * @LastEditTime: 2026-03-05 13:45:04
 * @LastEditors: Src
 * @FilePath: /work-station/src/router/carRouter/index.ts
 * @Description: 头部注释配置模板
 */
import carShopRoutes from './carShopRoutes';
import carListRoutes from './carListRoutes';
import carOrderRoutes from './carOrderRoutes';
import carAuditRoutes from './carAuditRoutes';
import carBrandRoutes from './carBrandRoutes';

const carRoutes: any = [
  carShopRoutes,
  carListRoutes,
  carOrderRoutes,
  carAuditRoutes,
  carBrandRoutes,
];

export default carRoutes;
